import { render, staticRenderFns } from "./AddUsulanPerubahan.vue?vue&type=template&id=fa0b2444&lang=pug&"
import script from "./AddUsulanPerubahan.vue?vue&type=script&lang=js&"
export * from "./AddUsulanPerubahan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports